import React from "react";
import { Box, Image, Card, Flex, Text, Hide, Link } from "@chakra-ui/react";
import myPic from "../img/myPic.jpeg";
import { MdEmail } from "react-icons/md";
import { BsGithub } from "react-icons/bs";
import { FaLinkedinIn } from "react-icons/fa";
import { themeContext } from "../context/Context";
import { useContext } from "react";
const Footer = () => {
  let theme = useContext(themeContext);
  let darkmode = theme.state.darkMode;
  return (
    <div>
      <Box h="28vh" w="100%">
        <Box
          h="100%"
          w="100%"
          boxShadow={"dark-lg"}
          borderBottom="18px solid orangered"
          alignItems={"center"}
        >
          <Hide below="sm">
            <Card
              w="6%"
              h="50%"
              m="auto"
              overflow="hidden"
              borderRadius={"50%"}
              top="-50px"
              boxShadow={"dark-lg"}
            >
              <Image src={myPic} h="100%" w="100%" />
            </Card>
          </Hide>
          <Text mt="-40px" color="orangered" fontSize={"2xl"}>
            Mitali Sinha
          </Text>
          <Card
            h="40%"
            w="15%"
            m="auto"
            style={{
              backgroundColor: darkmode
                ? "rgb(54, 53, 53)"
                : "rgb(217, 235, 252)",
              color: darkmode ? "rgb(240, 231, 231)" : "black",
            }}
          >
            <Flex h="100%" alignItems={"center"}>
              <Box h="100%" w="33%">
                <Box h="50%" w="50%" m="auto">
                  <MdEmail
                    size={["15", "20", "30", "40", "50"]}
                    color="#eb0e4d"
                  />
                </Box>
              </Box>
              <Box h="100%" w="34%">
                <Link href="https://github.com/mira713">
                  <Box h="50%" w="50%" m="auto">
                    <BsGithub
                      size={["15", "20", "30", "40", "50"]}
                      color="black"
                    />
                  </Box>
                </Link>
              </Box>
              <Box h="100%" w="33%">
                <Link href="https://www.linkedin.com/in/mitali-sinha-183134203/">
                  <Box h="50%" w="50%" m="auto">
                    <FaLinkedinIn
                      size={["15", "20", "30", "40", "50"]}
                      color="#2655f0"
                    />
                  </Box>
                </Link>
              </Box>
            </Flex>
          </Card>
        </Box>
      </Box>
    </div>
  );
};

export default Footer;
